import React from "react";
// import PropTypes from "prop-types";

import SubPurposeSelect from "../../shared/containers/filters/sub_purpose";
import RegulationsSelect from "../../shared/containers/filters/regulations";
import RegionsSelect from "../../shared/containers/filters/regions";

class AdvancedFilters extends React.Component {
  render () {
    return (
      <div className="advanced-filters">
        <div className="row">
          <SubPurposeSelect />
          <RegulationsSelect />
          <RegionsSelect />
        </div>
      </div>
    );
  }
}

AdvancedFilters.propTypes = {
  // searchIsBeingSaved: PropTypes.bool.isRequired,
};

export default AdvancedFilters;
